<script setup lang="ts">
import type { DeviceModel } from '@/types/models/DeviceModel'
import { StackLayout, TypographyItem, TypographyWithPrefix } from '@rfc/rfc-components-library'
import { type DateProviderType, EProviders } from '@rfc/rfc-components-library/types'
import moment from 'moment'
import { inject } from 'vue'
import DeviceUnavailabilityCardComponent from './DeviceUnavailability/DeviceUnavailabilityCardComponent.vue'

const { DATETIME_FORMAT } = inject<DateProviderType>(EProviders.DATE, {})

type Props = {
    data?: Partial<DeviceModel>
}
defineProps<Props>()
</script>

<template>
    <StackLayout direction="column" class="h-full space-between">
        <StackLayout v-if="data?.rental" direction="column" class="h-full flex-wrap rental-info">
            <TypographyItem :label="$t('device.rental.infoTitle')" />
            <TypographyWithPrefix
                v-if="data?.rental?.start_at"
                :prefix="$t('date.from')"
                :label="moment(data?.rental.start_at).format(DATETIME_FORMAT)"
                class="flex-wrap"
                boldLabel />
            <TypographyWithPrefix
                v-if="data?.rental?.end_at"
                :prefix="$t('date.to')"
                :label="moment(data?.rental.end_at).format(DATETIME_FORMAT)"
                class="flex-wrap"
                boldLabel />
        </StackLayout>
        <DeviceUnavailabilityCardComponent v-if="data" :data="data" />
    </StackLayout>
</template>

<style scoped lang="scss">
.rental-info {
    &:deep(.prefix-div) {
        row-gap: 0;
    }
}
</style>
